import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ComprobantesRoutes } from './comprobantes.routing';
import { NotificationsComponent } from '../../notifications/notifications.component';
import { UpgradeComponent } from '../../upgrade/upgrade.component';

import { AuthenticationService } from '../../services/auth/auth.service';

import {
  MatButtonModule,
  MatInputModule,
  MatRippleModule,
  MatTooltipModule,
} from '@angular/material';
@NgModule({
  imports: [
    RouterModule.forChild(ComprobantesRoutes)
  ],
  declarations: [
  ],
  providers: [
    AuthenticationService
  ]
})

export class ComprobantesModule {}



// WEBPACK FOOTER //
// ./src/app/pages/comprobantes/comprobantes.module.ts